var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{class:_vm.cssHeaderClass()},[_c('h1',{staticClass:"content__header__heading"},[_vm._v(_vm._s(_vm.title))])]),_c('blocks',{attrs:{"slug":_vm.slug,"blocks":_vm.blocks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }